/**
 * `@fim/futurex-vector` — the embedding + vector-store layer.
 *
 * DeepSeek-only system: DeepSeek has no embeddings endpoint, so retrieval
 * embeddings are computed entirely IN-PROCESS by {@link LocalEmbedder} (no
 * external vendor — the only external AI API in the system is DeepSeek). A
 * self-hosted neural embedder is the planned quality upgrade behind this same
 * {@link Embedder} interface — still no second vendor.
 */
export type { Embedder, VectorRecord, ScoredRecord, VectorStore } from './types.js';
export { LocalEmbedder } from './local-embedder.js';
export { FlatVectorStore } from './flat-store.js';

import { LocalEmbedder } from './local-embedder.js';
import type { Embedder } from './types.js';

/** The embedder for the DeepSeek-only system: the offline, in-process LocalEmbedder. */
export function createEmbedder(): Embedder {
  return new LocalEmbedder();
}
